var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0 pl-12", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
        [
          _c(
            "v-col",
            { staticClass: "pa-0", attrs: { cols: "12", id: "main_content" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { to: { path: "/setting" } },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                            "text-align": "center",
                          },
                          attrs: { cols: "auto", align: "center" },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("title")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "router-link",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { to: { path: "/setting/authority" } },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                            "text-align": "center",
                          },
                          attrs: { cols: "auto", align: "center" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.ts("shareUserPermissionSettings")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [_vm._v(" " + _vm._s(this.detailTitle) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content", cols: "12", align: "center" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0 pt-9 mb-15",
              attrs: { cols: "10", align: "left" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { align: "center", justify: "start" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "light_blue_btn ma-0 pa-0 pl-2 pr-2",
                      attrs: {
                        width: "auto",
                        height: "2rem",
                        id: "choose_file",
                        elevation: "0",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.chooseFile()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.ts("chooseFile")) + " ")]
                  ),
                  _c("input", {
                    ref: "fileInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: ".csv" },
                    on: { change: _vm.onFileChange },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0 pl-2", attrs: { cols: "auto" } },
                    [_vm._v(" " + _vm._s(_vm.fileName) + " ")]
                  ),
                ],
                1
              ),
              !_vm.isRegistering
                ? _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0 mt-2",
                      attrs: { align: "center", justify: "start" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          style: {
                            "background-color":
                              !_vm.fileLoaded || _vm.hasErrors
                                ? "#84d5fc !important"
                                : "#008dd0", // 배경색 조절
                            color:
                              !_vm.fileLoaded || _vm.hasErrors
                                ? "white !important"
                                : "white", // 글자색 조절
                          },
                          attrs: {
                            width: "auto",
                            height: "2rem",
                            id: "btn_register",
                            disabled: !_vm.fileLoaded || _vm.hasErrors,
                          },
                          on: { click: _vm.handleRegister },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("register")) + " ")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0 mt-2",
                      attrs: { align: "center" },
                    },
                    [_vm._v(" " + _vm._s(_vm.ts("registering")) + " ")]
                  ),
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0 mt-2" },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.formattedRecords,
                      dark: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "tr",
                              {
                                class: {
                                  "notchangeable-row": item.result === "ー",
                                  "highlight-row": item.result === "X",
                                },
                              },
                              _vm._l(_vm.headers, function (header) {
                                return _c(
                                  "td",
                                  { key: header.value },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          align: "center",
                                          "no-gutters": "",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            item.error[header.value]
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      bottom: "",
                                                      color:
                                                        "rgba(148,148,148,1.0)",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function (ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "red",
                                                                        small:
                                                                          "",
                                                                      },
                                                                    },
                                                                    "v-icon",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "mdi-alert"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      { staticClass: "ma-0" },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 text-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color: "red",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-alert"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color: "red",
                                                                  "font-size":
                                                                    "medium",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "入力エラーが発生しました！"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      { staticClass: "ma-0" },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "mt-1 pa-0 text-left",
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticStyle: {
                                                                color: "black",
                                                              },
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    item.error[
                                                                      header
                                                                        .value
                                                                    ]
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                style: {
                                                  color: item.error[
                                                    header.value
                                                  ]
                                                    ? "red"
                                                    : "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item[header.value]) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }